import endpoints from '../endpoints.ts';
import { fetch } from './helpers.ts';

interface IUser {
  id: number;
  customerId: number;
  firstName: string;
  lastName: string;
  title: string;
  emailAddress: string;
  customerName: string;
}

const tools = {
  user: {
    read: {
      all: async () => {
        const url = endpoints.tools.user.read.all();
        return await fetch<IUser[]>(url, 'GET');
      },
    },
  },
};

export default tools;